// extracted by mini-css-extract-plugin
module.exports = {"container":"e_v4","lang":"e_w4","pre":"e_x4","code":"e_y4","button":"e_z4"};